import React, { useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Box,
  Button,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import ShareIcon from "@mui/icons-material/Share";
// import FileCopyIcon from "@mui/icons-material/FileCopy";
import ShareIcon from "assets/images/share.png";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image";
import copyClipboard from "assets/images/copy-clipboard.png";
import UrlCopiedModal from "./UrlCopiedModal";
import SocialShareModal from "./SocialShareModal";

const QRShareModal = ({ open, onClose, userName, userImgUrl, qrUrl }) => {
  const qrRef = useRef(null);
  const [copiedModalOpen, setCopiedModalOpen] = useState<Boolean>(false);
  const [qrImageUrl, setQrImageUrl] = useState("");
  const [socialShareOpen, setSocialShareOpen] = useState<boolean>(false);
  console.log("socialShareOpen", socialShareOpen);
  const handleShare = async () => {
    // if (qrRef.current) {
    //   const dataUrl = await toPng(qrRef.current);
    //   setQrImageUrl(dataUrl); // Set the image URL to use with share buttons
    // }
    setSocialShareOpen(true);
    // try {
    //   const dataUrl = await toPng(qrRef.current);
    //   const blob = await (await fetch(dataUrl)).blob();
    //   const file = new File([blob], "qrcode.png", { type: "image/png" });

    //   if (navigator.canShare && navigator.canShare({ files: [file] })) {
    //     await navigator.share({
    //       title: `${userName}'s Rental Yard`,
    //       text: "Scan this QR to view the rental yard!",
    //       files: [file],
    //     });
    //   } else {
    //     alert("Sharing not supported on this browser.");
    //   }
    // } catch (error) {
    //   console.error("Share failed", error);
    // }
  };
  // const handleShare = async () => {
  //   const svg = qrRef.current?.querySelector("svg");

  //   if (!svg) return;

  //   // Create canvas and draw SVG on it
  //   const canvas = document.createElement("canvas");
  //   const svgData = new XMLSerializer().serializeToString(svg);
  //   const img = new Image();
  //   const svgBlob = new Blob([svgData], {
  //     type: "image/svg+xml;charset=utf-8",
  //   });
  //   const url = URL.createObjectURL(svgBlob);

  //   img.onload = async () => {
  //     canvas.width = img.width;
  //     canvas.height = img.height;
  //     const ctx = canvas.getContext("2d");
  //     ctx.drawImage(img, 0, 0);

  //     // Convert to blob
  //     canvas.toBlob(async (blob) => {
  //       const file = new File([blob], "qrcode.png", { type: "image/png" });

  //       if (navigator.canShare && navigator.canShare({ files: [file] })) {
  //         await navigator.share({
  //           files: [file],
  //           title: "My QR Code",
  //           text: "Scan to open the yard",
  //         });
  //       } else {
  //         alert("Your browser does not support file sharing.");
  //       }
  //     }, "image/png");

  //     URL.revokeObjectURL(url);
  //   };

  //   img.src = url;
  // };

  const handleCopy = () => {
    if (!navigator.clipboard) {
      alert("Clipboard API is not supported in your browser.");
      return;
    }

    navigator.clipboard
      .writeText(qrUrl)
      .then(() => {
        setCopiedModalOpen(true);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
        alert("Failed to copy the link to clipboard.");
      });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "80%",
            sm: "300px",
            md: "350px",
          },
          bgcolor: "#2e2e2e",
          border: "5px solid #faa61a",
          borderRadius: "10px",
          outline: "none",
          p: 3,
          maxHeight: "80vh",
          // position: "absolute",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: "-20px",
            right: "-20px",
            bgcolor: "#faa61a",
            color: "#000",
            "&:hover": {
              bgcolor: "#faa61a",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#fff", fontSize: "24px" }}
          >
            Share via QR Code
          </Typography>
          <Typography
            sx={{ fontWeight: "bold", color: "#faa61a", fontSize: "18px" }}
          >
            {userName}'s <span style={{ color: "#fff" }}>Rental Yard</span>
          </Typography>

          <Box
            ref={qrRef}
            sx={{
              background: "#fff",
              padding: "1.5rem",
              borderRadius: "16px",
              margin: "1rem auto",
              display: "inline-block",
              // position: "relative",
            }}
          >
            <Box sx={{ position: "relative", width: 200, height: 200 }}>
              <QRCode
                value={qrUrl}
                size={200}
                bgColor="#FFFFFF"
                fgColor="#000000"
                level="H" // High error correction
              />
              <Box
                component="img"
                src={userImgUrl}
                alt="user"
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  border: "3px solid white",
                  backgroundColor: "#fff", // Ensures contrast around the image
                }}
              />
            </Box>

            <Typography
              variant="subtitle1"
              sx={{
                color: "#faa61a",
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "1rem",
              }}
            >
              GoEquipMe
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body2"
          sx={{
            mb: 2,
            textAlign: "center",
            color: "#fff",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          Scan this code to instantly view the yard.
        </Typography>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 40,
              width: 40,
              cursor: "pointer",
              backgroundColor: "#fff",
              borderRadius: "50%",
            }}
            onClick={handleShare}
          >
            <img src={ShareIcon} alt="" height={24} width={24} />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 40,
              width: 40,
              cursor: "pointer",
              backgroundColor: "#fff",
              borderRadius: "50%",
            }}
          >
            <Box
              component="span"
              sx={{
                display: "inline-block",
                width: 24,
                height: 24,
                backgroundColor: "#faa61a",
                maskImage: `url(${copyClipboard})`,
                maskSize: "cover",
                maskRepeat: "no-repeat",
                WebkitMaskImage: `url(${copyClipboard})`,
                WebkitMaskSize: "cover",
                WebkitMaskRepeat: "no-repeat",
              }}
              onClick={handleCopy}
            />
          </Box>
        </Box>

        {copiedModalOpen && (
          <UrlCopiedModal
            open={copiedModalOpen}
            onClose={() => setCopiedModalOpen(false)}
          />
        )}
        {socialShareOpen && (
          <SocialShareModal
            open={socialShareOpen}
            onClose={() => setSocialShareOpen(false)}
            shareLink={qrUrl}
          />
        )}
      </Box>
    </Modal>
  );
};

export default QRShareModal;
